import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, CircularProgress } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { useContext, useEffect } from 'react';
import UserContext from '../UserContext';
import { StyledMuiLink } from '../components/StyledComponent';
import NoOrganisation from '../components/NoOrganisation';
export default function SubscriptionConfirmation() {
    const [searchParams] = useSearchParams();
    const userContext = useContext(UserContext);
    useEffect(() => {
        const stripeSession = searchParams.get('stripeSession');
        console.log('Stripe session', stripeSession);
    }, []);
    return (_jsxs("div", { children: [_jsx(Alert, { severity: "success", children: "Thanks for signing up with Bas Ready. You can now connect Xero Organisation(s) to get started" }), _jsx("br", {}), userContext.user && !userContext.user.hasActiveSubscription && (_jsxs("div", { children: [_jsx(CircularProgress, { size: "18px", color: "info", sx: { mr: 2 } }), "Waiting for stripe to update the subscription. It might take a few minutes. Please", ' ', _jsx(StyledMuiLink, { onClick: () => userContext.refreshUser(), children: "click here" }), " to refresh", ' '] })), (!userContext.user || userContext.user.hasActiveSubscription) && _jsx(NoOrganisation, {})] }));
}
